import setUserNoteData from './setUserNoteData';
import saveUserNoteService from '../services/saveUserNoteService';
import markUserNote from '../utils/markUserNote';
import { ClientItem } from 'owa-mail-store';
import UserNote from 'owa-mail-store/lib/store/schema/UserNote';
import { action, orchestrator } from 'satcheljs';

const addUserNote = action(
    'addUserNote',
    (
        element: HTMLElement,
        item: ClientItem,
        selectedText: string,
        userInputContent: string,
        instance: number,
        isExistingUserNote: boolean
    ) => ({
        element: element,
        item: item,
        selectedText: selectedText,
        userInputContent: userInputContent,
        instance: instance,
        isExistingUserNote: isExistingUserNote,
    })
);

orchestrator(addUserNote, actionMessage => {
    const {
        element,
        item,
        selectedText,
        userInputContent,
        instance,
        isExistingUserNote,
    } = actionMessage;

    const newUserNote: UserNote = {
        keyword: selectedText,
        instance: instance,
        content: userInputContent,
    };

    let itemNotes: UserNote[] = item.userNoteData ? item.userNoteData.slice() : [];

    if (!isExistingUserNote) {
        // Add user note to DOM
        markUserNote(element, item, selectedText, instance);
        itemNotes.push(newUserNote);
    } else {
        for (let i = 0; i < itemNotes.length; i++) {
            const note = itemNotes[i];
            if (note.instance == instance && note.keyword == selectedText) {
                itemNotes[i] = newUserNote;
                break;
            }
        }
    }

    // Add user note to local store
    setUserNoteData(item, itemNotes);

    // Add user note to the server
    saveUserNoteService(item.ItemId.Id, itemNotes);
});

export default addUserNote;
